import React, { useEffect } from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";

const ENV = process.env.REACT_APP_ENV;
const ACTIVE = ENV === "staging" || ENV === "master";

const PALETTE = {
    staging: { bg: "#f59f00", fg: "#1a1a1a", label: "STAGING ENVIRONMENT" },
    master: { bg: "#722ed1", fg: "#ffffff", label: "MASTER ENVIRONMENT" },
};

const HEIGHT = 24;

const STYLE_ID = "cl-env-banner-style";
const BANNER_CSS = `
.cl-env-banner {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${HEIGHT}px;
    line-height: ${HEIGHT}px;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    z-index: 10000;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    user-select: none;
    pointer-events: none;
}
.cl-env-banner .anticon {
    margin-right: 6px;
    vertical-align: -2px;
}
.cl-env-banner-active body,
body.cl-env-banner-active {
    padding-top: ${HEIGHT}px;
}
`;

const EnvBanner = () => {
    useEffect(() => {
        if (!ACTIVE) return undefined;
        if (!document.getElementById(STYLE_ID)) {
            const tag = document.createElement("style");
            tag.id = STYLE_ID;
            tag.innerHTML = BANNER_CSS;
            document.head.appendChild(tag);
        }
        document.body.classList.add("cl-env-banner-active");
        return () => {
            document.body.classList.remove("cl-env-banner-active");
        };
    }, []);

    if (!ACTIVE) return null;

    const palette = PALETTE[ENV];

    return (
        <div
            className="cl-env-banner"
            style={{ background: palette.bg, color: palette.fg }}
            role="status"
            aria-label={palette.label}
        >
            <ExclamationCircleFilled />
            {palette.label}
        </div>
    );
};

export default EnvBanner;
